<app-details-loader *ngIf="loadFlag || errorMsg" [errorMsg]="errorMsg" [Height]="'70vh'" [LoaderMarginTop]="'19%'"></app-details-loader>

<div *ngIf="!loadFlag && !errorMsg">
  <payarc-back-link label="Back to customers" route="/customer/customer-list"></payarc-back-link>

  <div class="cd-hero">
    <div class="cd-ava">{{customerInitials}}</div>
    <div class="cd-hero__main">
      <div class="cd-hero__name">{{customer.name || '--'}}</div>
      <div class="cd-hero__meta">{{customer.email}} &middot; <code>{{customer.customer_id}}</code></div>
    </div>
    <div class="pa-head__actions">
      <button type="button" payarcButton="primary" *ngIf="create_payment_permission" (click)="createCharge()">Charge</button>
      <button type="button" payarcButton="secondary" *ngIf="create_payment_permission && !isPaypalMerchant" (click)="createAch()">ACH charge</button>
      <button type="button" payarcButton="secondary" *ngIf="update_permission" (click)="updateCustomer()">Edit</button>
      <button type="button" payarcButton="secondary" class="cd-delete" *ngIf="delete_permission" (click)="onDelete()">Delete</button>
    </div>
  </div>

  <div class="cd-grid">
    <payarc-detail-card title="Account information" [rows]="accountInfoRows"></payarc-detail-card>
    <payarc-detail-card title="Invoicing settings" [rows]="invoicingSettingsRows"></payarc-detail-card>
  </div>

  <div class="pa-stack">
  <payarc-section-card heading="Cards" *ngIf="list_card_permission">
    <button scard-action type="button" payarcButton="secondary" class="cd-scard-action" *ngIf="update_permission && create_payment_permission && !isPaypalMerchant && add_card_permission" (click)="addCard()">+ Add card</button>
    <payarc-empty-state *ngIf="noCardAdded" title="No card is added"></payarc-empty-state>
    <ng-container *ngIf="!noCardAdded">
      <div class="card-face" *ngFor="let card of customer.card.data">
        <payarc-card-mark [width]="42" [brand]="card.brand"></payarc-card-mark>
        <div>
          <div class="card-face__name">{{card.first6digit ? (card.first6digit | CreditCardMaskPipe) : '**** **** ****'}}{{card.first6digit ? '** ****' : ''}} {{card.last4digit ? card.last4digit : '****'}}</div>
          <div class="card-face__meta">Expires {{card.exp_month}}/{{card.exp_year}}</div>
        </div>
        <div class="pm-actions">
          <span class="def-chip" *ngIf="card.is_default">Default</span>
          <button type="button" class="pm-edit" *ngIf="update_card_permission && !card.is_default" (click)="changeDefaultCard(card.id)">Make default</button>
          <button type="button" class="pm-edit" *ngIf="update_card_permission" (click)="editCard(card)">Edit</button>
          <button type="button" class="pm-edit cd-delete" *ngIf="delete_card_permission" (click)="deleteCard(card)">Delete</button>
        </div>
      </div>
    </ng-container>
  </payarc-section-card>

  <payarc-section-card heading="Bank accounts">
    <button scard-action type="button" payarcButton="secondary" class="cd-scard-action" *ngIf="create_payment_permission" (click)="addBankAccount()">+ Add bank account</button>
    <payarc-empty-state *ngIf="noBankAccAdded" title="No bank account is added"></payarc-empty-state>
    <ng-container *ngIf="!noBankAccAdded">
      <div class="card-face" *ngFor="let bankAccount of customer.bank_account.data">
        <div>
          <div class="card-face__name">{{bankAccount.account_type}} &middot; {{bankAccount.account_number || '----'}}</div>
          <div class="card-face__meta">Routing {{bankAccount.routing_number}} &middot; {{bankAccount.first_name}} {{bankAccount.last_name}}</div>
        </div>
        <div class="pm-actions">
          <span class="def-chip" *ngIf="bankAccount.is_default !== 0">Default</span>
          <button type="button" class="pm-edit" *ngIf="create_payment_permission && bankAccount.is_default === 0" (click)="makeDefaultBankAccount(bankAccount.id)">Make default</button>
          <a class="pm-edit" *ngIf="create_payment_permission" [routerLink]="redirect_link" [queryParams]="{id: bankAccount.id, cust_id: customer.customer_id}">Edit</a>
          <button type="button" class="pm-edit cd-delete" *ngIf="create_payment_permission" (click)="deleteBankAccount(bankAccount.id)">Delete</button>
        </div>
      </div>
    </ng-container>
  </payarc-section-card>

  <payarc-section-card heading="Transactions" [flush]="true" *ngIf="list_payment_permission">
    <div class="pa-table-wrap">
      <payarc-table>
        <thead>
          <tr><th class="num">Amount</th><th>Type</th><th>Status</th><th>Payment</th><th>Date</th></tr>
        </thead>
        <tbody>
          <tr *ngIf="customerCharge.length === 0 && customerACHChargeList.length === 0">
            <td class="pa-table__state-cell" colspan="5"><payarc-empty-state title="No payment is added"></payarc-empty-state></td>
          </tr>
          <tr class="cd-row" *ngFor="let charge of customerCharge" tabindex="0" (click)="redirectToChargeDetails(charge)" (keydown.enter)="redirectToChargeDetails(charge)">
            <td class="num strong">${{charge.amount/100 | number: '1.2-2'}} USD</td>
            <td class="muted">Card charge</td>
            <td><payarc-status-badge [status]="charge.status ? (charge.status | camalizeStr : true) : '--'" [variant]="statusVariant(charge.status)"></payarc-status-badge></td>
            <td class="muted">{{customer.email}}</td>
            <td class="muted">{{charge.created_at | dateFormat: 'MM/dd/yyyy hh:mm'}}</td>
          </tr>
          <tr class="cd-row" *ngFor="let charge of customerACHChargeList" tabindex="0" (click)="redirectToAchDetails(charge)" (keydown.enter)="redirectToAchDetails(charge)">
            <td class="num strong">${{charge.amount/100 | number: '1.2-2'}} USD</td>
            <td class="muted">ACH charge</td>
            <td><payarc-status-badge [status]="charge.status ? (charge.status | camalizeStr : true) : '--'" [variant]="statusVariant(charge.status)"></payarc-status-badge></td>
            <td class="muted">{{charge.bank_account?.data?.account_number || '----'}}</td>
            <td class="muted">{{charge.created_at | date: 'MM/dd/yyyy hh:mm a'}}</td>
          </tr>
        </tbody>
      </payarc-table>
    </div>
    <div class="cd-view-more" *ngIf="customer.charge.data?.length > 4 || customer.ach_charge.data?.length > 4">
      <button type="button" payarcButton="secondary" (click)="redirectToPaymentList()">View more transactions</button>
    </div>
  </payarc-section-card>

  <payarc-section-card heading="Subscriptions" [flush]="true">
    <button scard-action type="button" payarcButton="secondary" class="cd-scard-action" *ngIf="add_subscription_permission" (click)="openAddSubscription()">+ Add subscription</button>
    <div class="pa-table-wrap" *ngIf="list_subscription_permission">
      <payarc-table>
        <thead>
          <tr><th>Plan</th><th>Status</th><th class="num">Amount</th><th>Billing</th><th>Created</th></tr>
        </thead>
        <tbody>
          <tr *ngIf="customerSubscriptionList.length === 0">
            <td class="pa-table__state-cell" colspan="5"><payarc-empty-state title="No active subscriptions"></payarc-empty-state></td>
          </tr>
          <tr class="cd-row" *ngFor="let subscription of customerSubscriptionList" tabindex="0" (click)="openSubscriptionDetails(subscription)" (keydown.enter)="openSubscriptionDetails(subscription)">
            <td class="strong">{{subscription.plan.data.name || '-'}}</td>
            <td><payarc-status-badge [status]="subscription.status | camalizeStr : true" [variant]="subscriptionStatusVariant(subscription.status)"></payarc-status-badge></td>
            <td class="num">${{subscription.plan.data.amount ? subscription.plan.data.amount/100 : '-'}} USD</td>
            <td class="muted">Every {{subscription.plan.data.interval || '-'}}</td>
            <td class="muted">{{subscription.created_at | dateFormat: 'MM/dd/yyyy'}}</td>
          </tr>
        </tbody>
      </payarc-table>
    </div>
    <div class="cd-view-more" *ngIf="customerSubscriptionList.length > 4">
      <button type="button" payarcButton="secondary" (click)="redirectToSubscriptionList()">View more subscriptions</button>
    </div>
  </payarc-section-card>

  <payarc-section-card heading="Invoices" [flush]="true" *ngIf="list_invoice_permission">
    <div class="pa-table-wrap">
      <payarc-table>
        <thead>
          <tr>
            <th [attr.aria-sort]="ariaSort(sortDirection('name'))"><button type="button" class="pa-th-sort" (click)="setSorting('name')">Customer <payarc-sort-icon [direction]="sortDirection('name')"></payarc-sort-icon></button></th>
            <th class="num" [attr.aria-sort]="ariaSort(sortDirection('total'))"><button type="button" class="pa-th-sort" (click)="setSorting('total')">Amount <payarc-sort-icon [direction]="sortDirection('total')"></payarc-sort-icon></button></th>
            <th [attr.aria-sort]="ariaSort(sortDirection('amount_due'))"><button type="button" class="pa-th-sort" (click)="setSorting('amount_due')">Payment due <payarc-sort-icon [direction]="sortDirection('amount_due')"></payarc-sort-icon></button></th>
            <th [attr.aria-sort]="ariaSort(sortDirection('invoice_number'))"><button type="button" class="pa-th-sort" (click)="setSorting('invoice_number')">Invoice number <payarc-sort-icon [direction]="sortDirection('invoice_number')"></payarc-sort-icon></button></th>
            <th>Status</th>
            <th [attr.aria-sort]="ariaSort(sortDirection('created_at'))"><button type="button" class="pa-th-sort" (click)="setSorting('created_at')">Created <payarc-sort-icon [direction]="sortDirection('created_at')"></payarc-sort-icon></button></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="invoiceFlag">
            <tr class="pa-skeleton-row" *ngFor="let r of [1,2,3]">
              <td *ngFor="let c of [1,2,3,4,5,6]"><span class="pa-skeleton-bar"></span></td>
            </tr>
          </ng-container>
          <tr *ngIf="!invoiceFlag && InvoiceDetails.data.length === 0">
            <td class="pa-table__state-cell" colspan="6"><payarc-empty-state title="No invoices"></payarc-empty-state></td>
          </tr>
          <ng-container *ngIf="!invoiceFlag && InvoiceDetails.data.length > 0">
            <tr class="cd-row" *ngFor="let invoice of InvoiceDetails.data" tabindex="0" [routerLink]="invoicepath" [queryParams]="{id: invoice.id}" (keydown.enter)="openInvoiceDetails(invoice)">
              <td class="strong">{{invoice.customer.data.name || invoice.customer.data.email || invoice.customer.data.id || invoice.customer_id}}</td>
              <td class="num">${{invoice.total/100 | number: '1.2-2'}}</td>
              <td class="muted">{{invoice.amount_due ? '$' + (invoice.amount_due/100) : '$0.00'}}</td>
              <td class="muted">{{invoice.invoice_number || '---'}}</td>
              <td [title]="invoice.failure_message ? (invoice.failure_message | camalizeStr : true) : ''"><payarc-status-badge [status]="invoiceStatusLabel(invoice)" [variant]="invoiceStatusVariant(invoice)"></payarc-status-badge></td>
              <td class="muted">{{invoice.created_at ? (invoice.created_at | dateFormat: 'MM/dd/yyyy') : '---'}}</td>
            </tr>
          </ng-container>
        </tbody>
      </payarc-table>
    </div>
    <div class="cd-view-more" *ngIf="customer.invoice.data?.length > 5 && !invoiceFlag">
      <button type="button" payarcButton="secondary" (click)="redirectToInvoicesList()">View more invoices</button>
    </div>
  </payarc-section-card>

  <payarc-section-card heading="Events">
    <app-event *ngIf="customer" [url]="eventListUrl" [ComponentIdKey]="'customer_id'" [ComponentId]="customer.id"></app-event>
  </payarc-section-card>
  </div>
</div>
